import React, {useContext, useEffect} from "react";
import {Login} from "../Login";
import "./LoginFirstPageWrapper.scss"
import { useLocation } from "react-router-dom";
import {UserReactContext} from "../../../contexts/UserContext";
import {OtpLogin} from "../OtpLogin/OtpLogin";
import {I18nReactContext} from "../../../contexts/I18nContext";
import {languagesMap} from "../../../contexts/ContextLib";
import jwtDecode from "jwt-decode";
import {TOKEN_TYPE_SUPER_ADMIN_LOGIN} from "../../../Utils/Constants";

export const LoginFirstPageWrapper = ({otpLogin}) => {
    const userContext = useContext(UserReactContext);
    const {switchLanguage} = useContext(I18nReactContext);
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const token = query.get('t');
    const ssoToken = query.get('ssoToken');
    
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const ssoToken = query.get('ssoToken');
        const langParam = query.get('lang');

        // Only logout for regular SSO tokens, NOT for super admin login tokens
        // Super admin tokens need to preserve the SA session for return
        if (ssoToken) {
            try {
                // Decode JWT to check if it's a super admin token
                const decodedToken = jwtDecode(ssoToken);
                const isSuperAdminToken = decodedToken.type === TOKEN_TYPE_SUPER_ADMIN_LOGIN;

                // Only logout if it's NOT a super admin token
                if (!isSuperAdminToken) {
                    userContext.logout({noRedirect: true});
                }
            } catch (error) {
                // If token decode fails, assume it's a regular SSO token and logout
                console.error('Failed to decode SSO token:', error);
                userContext.logout({noRedirect: true});
            }
        }

        // Handle language parameter - normalize to proper case (e.g., 'ruru' -> 'ruRU', 'enus' -> 'enUS')
        if (langParam) {
            // Create a case-insensitive lookup map
            const normalizedLangMap = {
                'heil': 'heIL',
                'enus': 'enUS',
                'aril': 'arIL',
                'ruru': 'ruRU'
            };

            // First try exact match (handles 'heIL', 'enUS', 'ruRU', 'arIL')
            // Then try normalized lowercase match (handles 'heil', 'enus', 'ruru', 'aril')
            const langCode = normalizedLangMap[langParam.toLowerCase()];

            // Verify the language code exists in languagesMap
            if (langCode && languagesMap[langCode]) {
                switchLanguage({newSelectedLanguage: langCode});
            }
        }
    }, [])
    
    return <div className="login-first-page-wrapper">
        <div className="login-comp-wrapper">
            {otpLogin ? (
                <OtpLogin token={token} ssoToken={ssoToken} doNotRedirectOnSuccess={false} />
            ) : (
                <Login 
                    token={token} 
                    ssoToken={ssoToken} 
                    doNotRedirectOnSuccess={false}
                />
            )}
        </div>
    </div>
}